import React, { useState, useEffect, useRef } from 'react';
import { searchOrders } from '../../store/action/order';
import { isAuthenticated } from "../../store/action/auth";
import ReactInterval from "react-interval";
import { Row, Col } from "react-bootstrap";
import numeral from 'numeral';
import { statusTranslate } from '../../services/helpers/status';
import { normalizeCourierServices } from '../../services/helpers/courier';
import { ModalOrderDetail } from "../../screens/order/components";

const SerachBar = props => {
    const [ searchValue, setSearchValue ] = useState('');
    const [ searchDone, setSearchDone] = useState(false);
    const [ orderId, setOrderId ] = useState('');
    const [ modalOrder, setModalOrder ] = useState(false);
    const [ loading, setLoading ] = useState(false);
    const [ results, setResults ] = useState([]);
    const { token } = isAuthenticated();
    const node = useRef();

    useEffect(() => {
        document.addEventListener("mousedown", handleClick);
        return () => {
          document.removeEventListener("mousedown", handleClick);
        };
    }, []);

    const handleClick = e => {
        if (node.current.contains(e.target)) {
            // inside click
            return;
        }
        setSearchValue("");
        props.onSearchActive(false)
        setResults([])
        setLoading(false)
        setSearchDone(false)
    };

    const onSearch = async () => {
        const resp = await searchOrders(searchValue,token)
        if (!resp.success) {
            console.log("failed");
        }
        
        setResults(resp.orders);
        setLoading(false);
        setSearchDone(true);
    }

    const badge = (status) => {
        let color,text;
        switch(status) {
            case 'delivered':
                color = 'badge-success';
                text = `Selesai`
                break;
            case 'cancelled':
                text = `Selesai`
                break;
            case 'rejected':
            case 'courierNotFound':    
                color = ''
                break;
            default:
                color = `badge-warning`;
                break;    
        }
        return color;
    }

    const onChange = (e) => {
        if (e.target.value === "")  {
            setSearchValue("");
            props.onSearchActive(false)
            setResults([])
            setLoading(false)
            setSearchDone(false)
            return;
        }
        props.onSearchActive(true)
        setSearchValue(e.target.value);
        setLoading(true); 
        setSearchDone(false)
    };

    const onClickSelection = (id) => {
        setModalOrder(true);
        setOrderId(id);
        setSearchValue("");
        setResults([])
        setLoading(false)
        setSearchDone(false)
        props.onSearchActive(false)
    };

    return (
        <div className="search-bar" ref={node}>
            {
                searchValue === "" ? null :  
                    <ReactInterval
                        timeout={1200}
                        enabled={loading}
                        callback={() => onSearch()}
                    />
            }
            {
                !modalOrder ? null :
                    <ModalOrderDetail 
                        show={modalOrder} 
                        onHide={() => setModalOrder(false)}
                        orderId={orderId}
                    />
            }
            <div style={{borderRadius:'32px'}} className="form-group mb-0 input-group-sm">
            <div
                style={{borderRadius:'32px', width:'50rem'}} 
                className="input-group location-search-input"
            >
                <div className="input-group-prepend">
                <span style={{border:'0px'}}  className="input-group-text bg-white">
                    <i className="fas fa-search"/>
                </span>
                </div>
                <input
                    type="text"
                    style={{boxShadow:'none'}} 
                    className="location-search-input form-control"
                    placeholder={"Cari nama penerima, nomor resi, nama kurir, atau order id..."}
                    onChange={e => onChange(e)}
                    value={searchValue}
                />
            </div>
                
                  <div
                      className="autocomplete-dropdown-container bg-white rounded border block mt-3"
                      style={{position:'absolute', zIndex:99 }}>
                    {
                        results.length === 0 ? "" : 
                            <div>
                                <div className="py-1 px-2 bg-secondary border-bottom">
                                    Memunculkan semua pencarian untuk: <b>{searchValue}</b>
                                </div>    
                                {
                                    results.map((i,idx) => {
                                        const { companyName, typeView } = normalizeCourierServices(i.courier.company,i.courier.type)
                                        return (
                                            <div 
                                                key={idx} 
                                                style={{width:'50rem'}}
                                                className="search-item  col-12 border-bottom p-1 px-4 pointer search-result"
                                                onClick={() => onClickSelection(i._id)}
                                            >
                                                <Row className="justify-content-between">
                                                    <Col className="text-muted">
                                                        <small>
                                                            ORDER ID: {i._id.toUpperCase()}
                                                        </small>
                                                    </Col>
                                                    <Col className="text-muted text-right">
                                                        <span className={`badge ${badge(i.status)} mr-2`}>
                                                            {statusTranslate(i.status)}
                                                        </span>
                                                        <small>
                                                            Rp. {numeral(i.price).format("0,0")}
                                                        </small>
                                                    </Col>
                                                </Row>
                                                <Row className="justify-content-between">
                                                    <Col className="">
                                                        <b>{i.receiver.name}</b>
                                                    </Col>
                                                    <Col className="text-muted text-right">
                                                        <b className="badge">{i.courier.waybillId ? `RESI: ${i.courier.waybillId}` : null}</b> {companyName} - { typeView }
                                                    </Col>
                                                </Row>
                                                
                                            </div>
                                        )
                                    })
                                }
                                {/* <div className="py-1 px-2 bg-secondary border-bottom">
                                    <b>Klik disini untuk mengeluarkan semua</b>
                                </div>  */}
                            </div>
                       
                    }
                    {
                        results.length === 0 && searchDone ? 
                            <div 
                                style={{width:'50rem'}} 
                                className="text-center p-2"
                            > 
                                Tidak ada hasil
                            </div> : ""
                    }
                    {
                        loading ? 
                            <div 
                                style={{width:'50rem'}} 
                                className="text-center p-2"
                            > 
                                <i className="mr-2 fas fa-circle-notch fa-spin"></i>
                                Loading...
                            </div> : ""
                    }
                </div>
            </div>
         
        </div>
    )
}

export default SerachBar